import React from 'react';
import logoWisby from '../../assets/logo.png';
import './CaseHeader.css';

export default function CaseHeader({ title, titleId, folio, stage, saveStatus, saveState='saved',
  onClose, onLogoClick, closeDisabled=false, closeRef }) {
  return <header className="wisby-case-header">
    <div className="wisby-case-identity">
      {onLogoClick
        ? <button type="button" className="wisby-case-logo" onClick={onLogoClick}
            aria-label="Volver al inicio de Wisby"><img src={logoWisby} alt="Wisby" /></button>
        : <span className="wisby-case-logo"><img src={logoWisby} alt="Wisby" /></span>}
      <div className="wisby-case-copy">
        <span className="wisby-case-eyebrow">WISBY · EXPEDIENTE DE PODER</span>
        <h2 id={titleId}>{title || 'Solicitud de poder'}</h2>
        <p><span>{folio || 'Folio pendiente'}</span>{stage && <span className="wisby-case-stage">{stage}</span>}</p>
      </div>
    </div>
    <div className="wisby-case-actions">
      {saveStatus && <span className="wisby-case-save" data-state={saveState} role="status">{saveStatus}</span>}
      <button ref={closeRef} type="button" className="wisby-case-close"
        disabled={closeDisabled} aria-label="Cerrar expediente" onClick={onClose}>×</button>
    </div>
  </header>;
}
